import { useEffect, useState } from "react";
import { supabase } from "../supabase";

const ALL_PERMISSIONS = [
  { key: "recipes", label: "📖 Рецепты" },
  { key: "products", label: "🥕 Продукты" },
  { key: "users", label: "👥 Пользователи" },
  { key: "substitutions", label: "🔄 Замены" },
  { key: "generate", label: "✨ ИИ Генерация" },
  { key: "support", label: "💬 Поддержка" },
  { key: "logs", label: "📋 Логи" },
  { key: "notifications", label: "🔔 Уведомления" },
  { key: "promocodes", label: "🎟️ Промокоды" },
  { key: "banners", label: "🖼️ Баннеры" },
  { key: "duplicates", label: "🔍 Дубликаты" },
  { key: "subscriptions", label: "💳 Подписки" },
  { key: "team", label: "👑 Команда" },
];

export default function Team() {
  const [admins, setAdmins] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const [newRole, setNewRole] = useState("admin");
  const [newPerms, setNewPerms] = useState<string[]>([]);
  const [newNotes, setNewNotes] = useState("");
  const [saving, setSaving] = useState(false);
  const [editId, setEditId] = useState<string | null>(null);
  const [editPerms, setEditPerms] = useState<string[]>([]);

  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchAdmins = async () => {
    setLoading(true);
    const { data } = await supabase
      .from("admin_users")
      .select("*")
      .order("created_at");
    if (data) setAdmins(data);
    setLoading(false);
  };

  const addAdmin = async () => {
    if (!newEmail.trim()) return;
    setSaving(true);
    const { error } = await supabase.from("admin_users").insert({
      email: newEmail.trim().toLowerCase(),
      role: newRole,
      permissions: newPerms,
      created_by: "tkanafin57@gmail.com",
      notes: newNotes.trim() || null,
    });
    if (error) {
      alert("Ошибка: " + error.message);
    } else {
      setShowAdd(false);
      setNewEmail("");
      setNewRole("admin");
      setNewPerms([]);
      setNewNotes("");
      fetchAdmins();
    }
    setSaving(false);
  };

  const savePerms = async (id: string) => {
    setSaving(true);
    await supabase
      .from("admin_users")
      .update({ permissions: editPerms })
      .eq("id", id);
    setEditId(null);
    fetchAdmins();
    setSaving(false);
  };

  const toggleActive = async (admin: any) => {
    if (admin.role === "owner") return;
    await supabase
      .from("admin_users")
      .update({ is_active: !admin.is_active })
      .eq("id", admin.id);
    fetchAdmins();
  };

  const deleteAdmin = async (id: string) => {
    if (!window.confirm("Удалить администратора?")) return;
    await supabase.from("admin_users").delete().eq("id", id);
    fetchAdmins();
  };

  const togglePerm = (
    perm: string,
    perms: string[],
    setPerms: (p: string[]) => void,
  ) => {
    if (perms.includes(perm)) {
      setPerms(perms.filter((p) => p !== perm));
    } else {
      setPerms([...perms, perm]);
    }
  };

  if (loading) return <div style={{ padding: 32 }}>Загрузка...</div>;

  return (
    <div>
      <div style={styles.header}>
        <h2 style={styles.title}>👑 Команда</h2>
        <button style={styles.addBtn} onClick={() => setShowAdd(true)}>
          + Добавить админа
        </button>
      </div>

      {showAdd && (
        <div style={styles.addCard}>
          <h3 style={styles.addTitle}>Новый администратор</h3>
          <div style={styles.fieldRow}>
            <label style={styles.label}>Email</label>
            <input
              style={styles.input}
              type="email"
              placeholder="admin@example.com"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
            />
          </div>
          <div style={styles.fieldRow}>
            <label style={styles.label}>Роль</label>
            <select
              style={styles.input}
              value={newRole}
              onChange={(e) => setNewRole(e.target.value)}
            >
              <option value="admin">Админ</option>
              <option value="moderator">Модератор</option>
            </select>
          </div>
          <div style={styles.fieldRow}>
            <label style={styles.label}>Заметка</label>
            <input
              style={styles.input}
              placeholder="Например: контент-менеджер"
              value={newNotes}
              onChange={(e) => setNewNotes(e.target.value)}
            />
          </div>
          <div style={styles.fieldRow}>
            <label style={styles.label}>Доступы</label>
            <div style={styles.permsGrid}>
              {ALL_PERMISSIONS.map((p) => (
                <label key={p.key} style={styles.permItem}>
                  <input
                    type="checkbox"
                    checked={newPerms.includes(p.key)}
                    onChange={() => togglePerm(p.key, newPerms, setNewPerms)}
                  />{" "}
                  {p.label}
                </label>
              ))}
            </div>
          </div>
          <div style={styles.addBtns}>
            <button style={styles.cancelBtn} onClick={() => setShowAdd(false)}>
              Отмена
            </button>
            <button style={styles.saveBtn} onClick={addAdmin} disabled={saving}>
              {saving ? "Сохранение..." : "Добавить"}
            </button>
          </div>
        </div>
      )}

      <div style={styles.adminsList}>
        {admins.map((admin) => (
          <div
            key={admin.id}
            style={{ ...styles.adminCard, opacity: admin.is_active ? 1 : 0.5 }}
          >
            <div style={styles.adminHeader}>
              <div>
                <span style={styles.adminEmail}>{admin.email}</span>
                <span
                  style={{
                    ...styles.roleBadge,
                    backgroundColor:
                      admin.role === "owner" ? "#f39c12" : "#3498db",
                  }}
                >
                  {admin.role === "owner"
                    ? "👑 Владелец"
                    : admin.role === "admin"
                      ? "🔧 Админ"
                      : "📝 Модератор"}
                </span>
                {!admin.is_active && (
                  <span style={styles.inactiveBadge}>Неактивен</span>
                )}
                {admin.notes && <span style={styles.notes}>{admin.notes}</span>}
              </div>
              {admin.role !== "owner" && (
                <div style={styles.adminActions}>
                  <button
                    style={styles.editBtn}
                    onClick={() => {
                      setEditId(editId === admin.id ? null : admin.id);
                      setEditPerms(admin.permissions || []);
                    }}
                  >
                    ✏️ Права
                  </button>
                  <button
                    style={{
                      ...styles.toggleBtn,
                      backgroundColor: admin.is_active ? "#e67e22" : "#2ECC71",
                    }}
                    onClick={() => toggleActive(admin)}
                  >
                    {admin.is_active ? "Отключить" : "Включить"}
                  </button>
                  <button
                    style={styles.deleteBtn}
                    onClick={() => deleteAdmin(admin.id)}
                  >
                    🗑️
                  </button>
                </div>
              )}
            </div>

            <div style={styles.permsList}>
              {(admin.permissions || []).map((p: string) => {
                const perm = ALL_PERMISSIONS.find((x) => x.key === p);
                return perm ? (
                  <span key={p} style={styles.permBadge}>
                    {perm.label}
                  </span>
                ) : null;
              })}
              {(admin.permissions || []).length === 0 &&
                admin.role !== "owner" && (
                  <span style={styles.noPerms}>Нет доступов</span>
                )}
              {admin.role === "owner" && (
                <span style={styles.permBadge}>🌟 Полный доступ</span>
              )}
            </div>

            {editId === admin.id && (
              <div style={styles.editBlock}>
                <div style={styles.permsGrid}>
                  {ALL_PERMISSIONS.map((p) => (
                    <label key={p.key} style={styles.permItem}>
                      <input
                        type="checkbox"
                        checked={editPerms.includes(p.key)}
                        onChange={() =>
                          togglePerm(p.key, editPerms, setEditPerms)
                        }
                      />{" "}
                      {p.label}
                    </label>
                  ))}
                </div>
                <div style={styles.addBtns}>
                  <button
                    style={styles.cancelBtn}
                    onClick={() => setEditId(null)}
                  >
                    Отмена
                  </button>
                  <button
                    style={styles.saveBtn}
                    onClick={() => savePerms(admin.id)}
                    disabled={saving}
                  >
                    {saving ? "..." : "Сохранить"}
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 24,
  },
  title: { fontSize: 24, fontWeight: 700, color: "#222", margin: 0 },
  addBtn: {
    padding: "10px 20px",
    backgroundColor: "#2ECC71",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 14,
  },
  addCard: {
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 24,
    marginBottom: 24,
    border: "1px solid #2ECC71",
  },
  addTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: "#222",
    marginBottom: 16,
    marginTop: 0,
  },
  fieldRow: { marginBottom: 16 },
  label: {
    display: "block",
    fontSize: 13,
    fontWeight: 600,
    color: "#555",
    marginBottom: 6,
  },
  input: {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 8,
    border: "1px solid #eee",
    fontSize: 14,
    boxSizing: "border-box" as const,
  },
  permsGrid: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8 },
  permItem: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 13,
    cursor: "pointer",
  },
  addBtns: {
    display: "flex",
    gap: 8,
    justifyContent: "flex-end",
    marginTop: 16,
  },
  cancelBtn: {
    padding: "10px 20px",
    borderRadius: 8,
    border: "1px solid #ddd",
    backgroundColor: "#fff",
    cursor: "pointer",
    fontSize: 14,
  },
  saveBtn: {
    padding: "10px 20px",
    backgroundColor: "#2ECC71",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 14,
  },
  adminsList: { display: "flex", flexDirection: "column", gap: 12 },
  adminCard: {
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 20,
    border: "1px solid #eee",
  },
  adminHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 12,
  },
  adminEmail: { fontSize: 15, fontWeight: 600, color: "#222", marginRight: 8 },
  roleBadge: {
    fontSize: 11,
    padding: "2px 8px",
    borderRadius: 20,
    color: "#fff",
    fontWeight: 600,
    marginRight: 6,
  },
  inactiveBadge: {
    fontSize: 11,
    padding: "2px 8px",
    borderRadius: 20,
    backgroundColor: "#eee",
    color: "#888",
    fontWeight: 600,
    marginRight: 6,
  },
  notes: { fontSize: 12, color: "#888", fontStyle: "italic" },
  adminActions: { display: "flex", gap: 8 },
  editBtn: {
    padding: "6px 12px",
    borderRadius: 6,
    border: "1px solid #ddd",
    backgroundColor: "#fff",
    cursor: "pointer",
    fontSize: 12,
  },
  toggleBtn: {
    padding: "6px 12px",
    borderRadius: 6,
    border: "none",
    color: "#fff",
    cursor: "pointer",
    fontSize: 12,
    fontWeight: 600,
  },
  deleteBtn: {
    padding: "6px 10px",
    borderRadius: 6,
    border: "1px solid #ffcccc",
    backgroundColor: "#fff5f5",
    cursor: "pointer",
    fontSize: 12,
  },
  permsList: { display: "flex", flexWrap: "wrap", gap: 6 },
  permBadge: {
    fontSize: 11,
    padding: "3px 10px",
    borderRadius: 20,
    backgroundColor: "#f0faf4",
    color: "#2ECC71",
    border: "1px solid #2ECC71",
  },
  noPerms: { fontSize: 12, color: "#aaa" },
  editBlock: { marginTop: 16, paddingTop: 16, borderTop: "1px solid #eee" },
};
